export interface RemoteFile {
  id: string
  name: string
  size: number
  link: string
  created_at: string
}

export type UploaderFile = File | RemoteFile

export const isRemoteFile = (file: UploaderFile): file is RemoteFile => !(file instanceof File)

export const isLocalFile = (file: UploaderFile): file is File => file instanceof File

export enum DisplayMode {
  IMAGE_ONLY = 'image',
  IMAGE_WITH_TEXT = 'imageWithText'
}

export type FileState = 'loaded' | 'loading' | 'error'
